import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';

export const Comparison = ({ t }) => (
  <section className="section comparison" id="advantages">
    <Reveal>
      <SectionHeading eyebrow={t('comparison.eyebrow')} title={t('comparison.title')} align="center" />
    </Reveal>

    <Reveal className="comparison__card" delay={100}>
      <div className="comparison__row comparison__row--head">
        <span />
        <strong>{t('comparison.rent')}</strong>
        <strong>{t('comparison.dev')}</strong>
      </div>
      {t('comparison.rows').map(([name, rent, dev]) => (
        <div className="comparison__row" key={name}>
          <strong>{name}</strong>
          <span>{rent}</span>
          <span>{dev}</span>
        </div>
      ))}
    </Reveal>

    <Reveal delay={180}>
      <p className="comparison__note">{t('comparison.note')}</p>
    </Reveal>
  </section>
);
